import { VALTYPES } from '../../../../data/interfaces';
import { createConfigParamLabelSpace, createConfigParamTypeDiscreteColorScheme } from '../../helpers/configParams';
import { TpChartManifest } from '../interfaces';
import { Piechart } from './Piechart';

export const manifestPiechart: TpChartManifest = {
  id: 'PieChart',
  name: 'Pie chart',
  description: `Displays the distribution of a categorical property by showing the number of occurrences of each different state as slices.
The angle is proportional to the number of occurrences. It can be used to highlight each state as a fraction of the total number of values.

**NOTE:** This type of visualization only makes sense if the property contains a few states only.`,
  component: Piechart,
  canvasBased: true,
  groups: [
    { groupId: 'categories', groupName: 'Categories' },
    { groupId: 'radius', groupName: 'Radius' },
  ],
  aspects: [
    {
      id: 'value',
      name: 'Categories data',
      groupId: 'categories',
      description: 'Property to show the distribution for.',
      required: true,
      quality: 1,
      dataType: VALTYPES.CATEGORICAL,
    },
    {
      id: 'radius',
      name: 'Radius data',
      groupId: 'radius',
      description:
        'An optional second numerical property. The average value within each slice is used as radius for the pie.',
      required: false,
      quality: 0.25,
      dataType: [VALTYPES.NUMBER, VALTYPES.INTEGER],
    },
  ],
  configParams: [
    {
      id: 'labelSpace',
      name: 'Label space',
      groupId: 'categories',
      description:
        'Scaling factor that determines how much space in the chart is used by the names of the different pies.',
      paramType: createConfigParamLabelSpace(),
    },
    {
      id: 'valueSchemeCategorical',
      name: 'Color scheme',
      groupId: 'categories',
      description: 'Discrete color palette used to color the different pies.',
      paramType: createConfigParamTypeDiscreteColorScheme(),
    },
  ],

  examples: [
    {
      id: 'piechart_1',
    },
    {
      id: 'piechart_2',
    },
  ],
};
